// Severity is a fixed Low / Medium / High / Critical radio. The bot's
// modal builder owns the option labels (see bot-interactions.md); the
// studio does not customise them.

export function SeverityConfig(): JSX.Element {
  return (
    <p className="text-xs text-text-muted">
      Players choose between <strong>Low</strong>, <strong>Medium</strong>,{' '}
      <strong>High</strong>, and <strong>Critical</strong>.
    </p>
  );
}
